import { Redirect, Route, Switch } from 'react-router-dom'

interface PanelRoute {
  component: (params: any) => JSX.Element
  path: string
}

interface PanelRoutesProps {
  defaultRoute: string
  panelRoutes: PanelRoute[]
}

function PanelRoutes(props: PanelRoutesProps) {
  const { defaultRoute, panelRoutes } = props

  return (
    <Switch>
      {panelRoutes.map(({ component, path }) => (
        <Route key={path} path={path} component={component} exact />
      ))}
      <Route path="*">
        <Redirect to={defaultRoute} />
      </Route>
    </Switch>
  )
}

export default PanelRoutes
